import(/* webpackMode: "eager" */ "/home/runner/work/c_social/c_social/src/app/loading.tsx");
